// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"608":"18efbcc7","995":"948c6cc6"}[chunkId] + ".chunk.js");